<template>
  <div v-if="showPros" :class="spacingClasses">
    <ProsCollection
      :panel-config="{
        componentType: 'RviCarousel',
        panelType: 'rvi',
        openInNewTab: prosInNewTab,
        properties: killswitches,
        customStyleClass: 'custom-zone-rvi-styling',
        customHeaderType: 'div',
        headerRole: 'heading',
        headerAriaLevel: '3',
        showDivider: ref(type === 'unavailable' && newUnavailablePage),
      }"
      :recommendation-config="recommendationConfig"
      @data-load-status-event="loader"
    />
  </div>
</template>

<script setup>
import ProsCollection from '@nuxt-common/pros-collection/app/components/ProsCollection.vue';
import { useBrand } from '~/composables/useBrand';
import { usePageData } from '~/composables/usePageData';
import useSelectedMemberId from '~/modules/latchkey/composables/useSelectedMemberId';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { useProductType } from '~/composables/useProductType';
import useProsLoader from '~/composables/utils/useProsLoader';
import parseFacetsFromUrl from '~/utils/parseUrl';

const { isMcom } = useBrand();
const { prosInNewTab, shoppableRedesignOptimization } = useFeatureEligibility();
const { killswitches } = usePageData();
const selectedMemberId = useSelectedMemberId();
const { showPros, loader } = useProsLoader();
const { type } = useProductType();
const spacingClasses = shoppableRedesignOptimization
  ? 'small-margin-bottom-m large-margin-bottom-xl'
  : 'small-margin-bottom-xl large-margin-bottom-xxl';
const facets = parseFacetsFromUrl();
const {
  killswitches: { newUnavailablePage },
} = useKillswitches();

const recommendationConfig = computed(() => ({
  zone: isMcom ? 'rvi_pdp_zone' : 'RVI_PDP',
  productId: selectedMemberId.value.toString(),
  ...facets,
}));
</script>

<style lang="scss">
@import '~@core/csg/src/scss/typography/typography-mixins.scss';

@include breakpoint(small only) {
  .custom-zone-rvi-styling {
    .header-container > div:first-child {
      @include header(h4);
    }
  }
}

.custom-zone-rvi-styling {
  .header-container > div:first-child {
    @include header(h3);
  }
}
</style>
